function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
import delay from 'lodash/delay';
import first from 'lodash/first';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import find from 'lodash/find';
import { abs } from 'mathjs';
import reverse from 'lodash/reverse';
import slice from 'lodash/slice';
import includes from 'lodash/includes';
import { ProfileContext } from 'context';
import DownloadIcon from 'svg/download-report.svg';
import PrinterIcon from 'svg/printer-filled.svg';
import Button from 'components/Form/Button';
import patientShape from 'shapes/patientShape';
import App, { IntlHelmet, LanguageProvider, OfflineOverlay } from 'modules/App';
import File from 'modules/File';
import Account from 'modules/Account';
import ClinicManagement from 'modules/ClinicManagement';
import Patient from 'modules/Patient';
import PatientResults from 'modules/PatientResults';
import Hcp from 'modules/Hcp';
// TODO move all report layouts to a proper place (Layout/ReportLayouts ??)
import PatientGestationalReportParams from '../../../PatientResults/components/PatientGestationalReport/PatientGestationalReportParams';
import messages from '../../messages';
import * as selectors from '../../selectors';
import * as actions from '../../actions';
import * as constants from '../../constants';
import BasicParams from './BasicParams';
import DailyLogParams from './DailyLogParams';
import Reports from './Reports';
import styles from './ReportsLayout.pcss';
const emptySelector = ()=>null;
var _React_Component;
class ReportsLayout extends (_React_Component = React.Component) {
    componentDidMount() {
        window.addEventListener('scroll', this.onScrollBind);
        window.addEventListener('afterprint', this.onAfterPrintBind);
        this.props.setWindowWidth(1024);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollBind);
        window.removeEventListener('afterprint', this.onAfterPrintBind);
    }
    onAfterPrint() {
        requestAnimationFrame(()=>this.setState({
                singleReportPrint: null,
                forcePrintState: false
            }));
    }
    onDownloadAll() {
        const reportTypes = constants.REPORT_TYPES.filter((reportType)=>includes(this.props.reportTypes, reportType));
        this.onDownload(reportTypes);
    }
    onScroll() {
        const bodyRect = document.body.getBoundingClientRect();
        const activeReportType = find(reverse(slice(this.props.reportTypes)), (reportType)=>{
            if (this.reportRefs[reportType]) {
                const ref = this.reportRefs[reportType].current;
                const reportRect = ref.getBoundingClientRect();
                return reportRect.y < abs(bodyRect.height) / 2;
            }
            return null;
        });
        this.setState({
            activeReportType
        });
    }
    onDownloadFile(event, reportType) {
        if (event) {
            event.stopPropagation();
        }
        this.onDownload([
            reportType
        ]);
    }
    onDownload(reportTypes) {
        const pdfReportSources = [];
        reportTypes.forEach((reportType)=>{
            if (reportType === 'patientsBgDataReportPrint') {
                this.setState({
                    downloadCsv: true
                });
                delay(()=>this.setState({
                        downloadCsv: false
                    }), 1000);
                return;
            }
            const ref = this.reportNamesRef.current.querySelector(`#${reportType}`);
            if (!ref) {
                return;
            }
            const translatedReportName = ref.innerText.replaceAll(' ', '_');
            const { firstName, lastName } = this.props.activePatient || {};
            const { firstName: accountFirstName, lastName: accountLastName } = get(this.props.reportsState, 'accountPatientProfile') || {};
            const fullName = `${firstName || accountFirstName}_${lastName || accountLastName}`;
            const filename = `${translatedReportName}_${fullName}_${new Date().toLocaleDateString().replaceAll('.', '_')}.pdf`;
            pdfReportSources.push({
                filename,
                ref: this.reportRefs[reportType]
            });
        });
        this.props.onDownloadPdfs(pdfReportSources);
    }
    onPrint(event, singleReportPrint) {
        event.stopPropagation();
        this.setState({
            singleReportPrint
        });
        this.setState({
            activeReportType: singleReportPrint
        });
        delay(()=>window.print(), 500);
    }
    onPrintAll() {
        this.setState({
            forcePrintState: true
        });
        delay(()=>window.print(), 500);
    }
    getIsNotPrintable(reportType) {
        const { singleReportPrint } = this.state;
        return reportType === 'patientsBgDataReportPrint' || singleReportPrint && singleReportPrint !== reportType;
    }
    scrollIntoView(reportType, behavior = 'smooth') {
        const ref = this.reportRefs[reportType];
        if (!ref || !ref.current) {
            return;
        }
        ref.current.scrollIntoView({
            behavior,
            block: 'start',
            inline: 'nearest'
        });
    }
    renderButtons() {
        if (!process.env.BROWSER) return null;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.reportsLayout__buttons,
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    id: "reportPrint",
                    type: "button",
                    styleModifier: "primary",
                    isDisabled: !this.props.isReportsInitialized,
                    onClick: ()=>this.onPrintAll(),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.reports.buttons.print))
                }),
                /*#__PURE__*/ _jsx(Button, {
                    id: "reportDownload",
                    type: "button",
                    isDisabled: !this.props.isReportsInitialized,
                    onClick: ()=>this.onDownloadAll(),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.reports.buttons.download))
                })
            ]
        });
    }
    renderReportName(reportType) {
        switch(reportType){
            case 'basicPrint':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.standardDashboardReport));
            case 'bloodGlucoseConcentrationPrint':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.bloodSugarReport));
            case 'dailyLogPrint':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.bloodSugarDiaryReport));
            case 'agpBgmPrint':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.AgpBgmDashboardReport));
            case 'patientsBgDataReportPrint':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.PatientsBgData));
            case 'patientsGestationalReportPrint':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.headers.patientsGestationalReport));
            case 'newCDADailyLogReportPrint':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.bloodSugarDiaryReport));
            case 'newCDABloodGlucoseConcentrationPrint':
                return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.bloodSugarReport));
            default:
                return null;
        }
    }
    renderReportParams(reportType) {
        if (reportType === 'basicPrint') {
            return /*#__PURE__*/ _jsx(BasicParams, {});
        }
        if (reportType === 'dailyLogPrint') {
            return /*#__PURE__*/ _jsx(DailyLogParams, {});
        }
        if (reportType === 'patientsGestationalReportPrint') {
            return /*#__PURE__*/ _jsx(PatientGestationalReportParams, {});
        }
        return null;
    }
    renderReportNames() {
        return map(this.props.reportTypes, (reportType)=>{
            const isActive = this.state.activeReportType === reportType;
            const isNotPrintable = this.getIsNotPrintable(reportType);
            return /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.reportsLayout__reportNameWrapper, {
                    [styles['reportsLayout__reportNameWrapper--isActive']]: isActive
                }),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: cn(styles.reportsLayout__reportName, {
                            [styles['reportsLayout__reportName--isActive']]: isActive,
                            [styles['reportsLayout__reportName--notPrintable']]: isNotPrintable
                        }),
                        onClick: ()=>this.scrollIntoView(reportType),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                id: reportType,
                                className: styles.reportsLayout__reportNameText,
                                children: this.renderReportName(reportType)
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.reportsLayout__actionIcons,
                                children: [
                                    /*#__PURE__*/ _jsx(DownloadIcon, {
                                        onClick: (event)=>this.onDownloadFile(event, reportType)
                                    }),
                                    !isNotPrintable && /*#__PURE__*/ _jsx(PrinterIcon, {
                                        onClick: (event)=>this.onPrint(event, reportType)
                                    })
                                ]
                            })
                        ]
                    }),
                    this.renderReportParams(reportType)
                ]
            }, reportType);
        });
    }
    renderSideBar() {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.reportsLayout__sideBar,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.reportsLayout__sectionTitle,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.reports.headers.files))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        ref: this.reportNamesRef,
                        className: styles.reportsLayout__reportNames,
                        children: this.renderReportNames()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.reportsLayout__separator
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.reportsLayout__sectionTitle,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.reports.headers.allFiles))
                    }),
                    this.renderButtons()
                ]
            })
        });
    }
    renderLoader() {
        if (!this.props.isInProgress) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: cn('col col-lg-8', styles.root__container),
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.root__loader,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.root__loaderBar
                })
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(LanguageProvider, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.reportsLayout, 'no-gutters', {
                    [styles.busy]: this.props.isInProgress
                }),
                children: [
                    /*#__PURE__*/ _jsx(IntlHelmet, {
                        titleMessage: _object_spread({}, messages.meta.title),
                        descriptionMessage: _object_spread({}, messages.meta.description)
                    }),
                    /*#__PURE__*/ _jsxs(ProfileContext.Provider, {
                        value: this.profileContext,
                        children: [
                            this.renderSideBar(),
                            /*#__PURE__*/ _jsxs("div", {
                                ref: this.rootRef,
                                className: cn(styles.reportsLayout__viewport, {
                                    [styles['reportsLayout__viewport--print']]: this.state.forcePrintState
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Reports, {
                                        reportRefs: this.reportRefs,
                                        downloadCsv: this.state.downloadCsv,
                                        forcePrintState: this.state.forcePrintState,
                                        singleReportPrint: this.state.singleReportPrint
                                    }),
                                    this.renderLoader()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(OfflineOverlay, {})
                ]
            })
        });
    }
    constructor(props){
        super(props);
        const { isHcp } = props;
        /* eslint-disable max-len */ this.profileContext = {
            selectors: {
                activePatient: PatientResults.selectors.reportsStateMedicalRecord,
                phiSet: PatientResults.selectors.reportsStatePhiSet,
                phiSetDocumentId: isHcp ? Hcp.selectors.phiSetDocumentId : Patient.selectors.phiSetDocumentId,
                readings: PatientResults.selectors.reportsStateReadings,
                batchesIndex: isHcp ? Hcp.selectors.batchesIndex : Patient.selectors.batchesIndex,
                readingsRangeDate: isHcp ? Hcp.selectors.readingsRangeDate : Patient.selectors.readingsRangeDate,
                highlightedReadings: isHcp ? Hcp.selectors.highlightedReadings : Patient.selectors.highlightedReadings,
                measurements: isHcp ? Hcp.selectors.measurements : Patient.selectors.measurements,
                measurementsBatchesIndex: isHcp ? Hcp.selectors.measurementsBatchesIndex : Patient.selectors.measurementsBatchesIndex,
                relatedData: PatientResults.selectors.reportsStateRelatedData,
                timeSeriesResources: PatientResults.selectors.reportsStateTimeSeriesResources,
                clinicSettings: isHcp ? ClinicManagement.selectors.clinicSettings : emptySelector
            },
            actions: {
                setReadings: isHcp ? Hcp.actions.setReadings : Patient.actions.setReadings
            }
        };
        /* eslint-enable max-len */ // this.updateScreenWidth = debounce(
        //   (shouldSetBaseMenuOpen) => this.onUpdateScreenWidth(shouldSetBaseMenuOpen),
        //   300,
        // );
        this.onScrollBind = debounce(()=>this.onScroll(), 50);
        this.onAfterPrintBind = this.onAfterPrint.bind(this);
        this.state = {
            activeReportType: first(props.reportTypes),
            singleReportPrint: null,
            forcePrintState: false,
            downloadCsv: false
        };
        this.rootRef = /*#__PURE__*/ React.createRef();
        this.reportNamesRef = /*#__PURE__*/ React.createRef();
        this.reportRefs = {
            basicPrint: /*#__PURE__*/ React.createRef(),
            bloodGlucoseConcentrationPrint: /*#__PURE__*/ React.createRef(),
            dailyLogPrint: /*#__PURE__*/ React.createRef(),
            agpBgmPrint: /*#__PURE__*/ React.createRef(),
            patientsBgDataReportPrint: /*#__PURE__*/ React.createRef(),
            patientsGestationalReportPrint: /*#__PURE__*/ React.createRef(),
            newCDADailyLogReportPrint: /*#__PURE__*/ React.createRef(),
            newCDABloodGlucoseConcentrationPrint: /*#__PURE__*/ React.createRef()
        };
    }
}
_define_property(ReportsLayout, "propTypes", {
    reportTypes: PropTypes.array,
    activePatient: patientShape,
    reportsState: PropTypes.object,
    showDayDividers: PropTypes.bool,
    isHcp: PropTypes.bool,
    isInProgress: PropTypes.bool,
    isReportsInitialized: PropTypes.bool,
    setWindowWidth: PropTypes.func,
    onDownloadPdfs: PropTypes.func
});
const mapStateToProps = (state)=>({
        windowWidth: selectors.windowWidth(state),
        showDayDividers: selectors.showDayDividers(state),
        reportsState: PatientResults.selectors.reportsState(state),
        isHcp: Account.selectors.isHcp(state),
        activePatient: Hcp.selectors.activePatient(state),
        reportTypes: PatientResults.selectors.reportTypes(state),
        isInProgress: File.selectors.isDownloadPdfInProgress(state),
        hasErrors: File.selectors.hasDownloadPdfErrors(state),
        isReportsInitialized: App.selectors.isReportsInitialized(state)
    });
const mapDispatchToProps = (dispatch)=>({
        setWindowWidth: (windowWidth, shouldSetBaseMenuOpen)=>dispatch(actions.setWindowWidth(windowWidth, shouldSetBaseMenuOpen)),
        onDownloadPdfs: (pdfReportSources)=>dispatch(File.actions.downloadPdfs(pdfReportSources))
    });
const ConnectedReportsLayout = connect(mapStateToProps, mapDispatchToProps)(ReportsLayout);
export default withStyles(styles)(ConnectedReportsLayout);
